import React from 'react';

interface AlertProps {
  type?: 'success' | 'error';
  message: string | React.ReactNode;
  onClose?: () => void;
  isHtml?: boolean;
  number_verify?: number;
  max_number_verify?: number;
}

const Alert: React.FC<AlertProps> = ({ 
  type = 'success', 
  message, 
  onClose,
  isHtml = false,
  number_verify,
  max_number_verify = 5
}) => {
  const bgColor = type === 'success' ? 'bg-[#bfe3d6]' : 'bg-[#e9e1d7]';
  const borderColor = type === 'success' ? 'border-[#a4cbba]' : 'border-[#ffdbb4]';
  const textColor = type === 'success' ? 'text-gray-700' : 'text-[#834747]';

  return (
    <div className={`relative p-6 mb-4 ${bgColor} border ${borderColor} rounded-lg ${textColor}`}>
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          aria-label="Close alert"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
      <h3 className='text-2xl font-bold mb-4 text-center'>{type ==='success' ? 'Kiểm tra thành công!' : 'Kiểm tra thất bại!'}</h3>
      {isHtml ? (
        <div dangerouslySetInnerHTML={{ __html: message as string }} />
      ) : (
        <div>{message}</div>
      )}
      {type === 'success' && number_verify && (
        <p className="mt-4 text-sm text-gray-500 text-center">
            Sản phẩm này đã xác thực <strong>{number_verify}/{max_number_verify} lần</strong> 
        </p>
      )}
    </div>
  );
};

export default Alert; 